// @ts-nocheck
import { config, configString } from '@amzn/aet-extend-website-strings';
import moment from 'moment/min/moment-with-locales';

import { getLocale, storage, storageLocaleKey } from '../config/Config';

export const splitLocale = (
  langTag: string
): {
  lang: string;
  loc: string;
} => {
  const splitLanguage = langTag.split(/[-_]/);
  return {
    lang: splitLanguage[0],
    loc: splitLanguage[1],
  };
};

export const chooseLocale = (): Record<string, string> => {
  const { lang, loc } = splitLocale(navigator.language);
  const enforcedLocale = getLocale();
  let locale = config.default;

  if (enforcedLocale) {
    const langLoc = splitLocale(enforcedLocale);
    if (
      Object.prototype.hasOwnProperty.call(config, langLoc.lang) &&
      Object.prototype.hasOwnProperty.call(config[langLoc.lang], langLoc.loc)
    ) {
      locale = config[langLoc.lang][langLoc.loc];
    } else if (
      Object.prototype.hasOwnProperty.call(config, langLoc.lang) &&
      Object.prototype.hasOwnProperty.call(config[langLoc.lang], 'default')
    ) {
      locale = config[langLoc.lang].default;
    }
  } else if (
    Object.prototype.hasOwnProperty.call(config, lang) &&
    Object.prototype.hasOwnProperty.call(config[lang], loc)
  ) {
    locale = config[lang][loc];
  } else if (
    Object.prototype.hasOwnProperty.call(config, lang) &&
    Object.prototype.hasOwnProperty.call(config[lang], 'default')
  ) {
    locale = config[lang].default;
  }
  return locale;
};

export const getLocaleString = (): string => {
  const { lang, loc } = splitLocale(navigator.language);
  const enforcedLocale = getLocale();
  let locale = configString.default;

  if (enforcedLocale) {
    const langLoc = splitLocale(enforcedLocale);
    if (
      Object.prototype.hasOwnProperty.call(config, langLoc.lang) &&
      Object.prototype.hasOwnProperty.call(config[langLoc.lang], langLoc.loc)
    ) {
      locale = configString[langLoc.lang][langLoc.loc];
    } else if (
      Object.prototype.hasOwnProperty.call(config, langLoc.lang) &&
      Object.prototype.hasOwnProperty.call(config[langLoc.lang], 'default')
    ) {
      locale = configString[langLoc.lang].default;
    }
  } else if (
    Object.prototype.hasOwnProperty.call(config, lang) &&
    Object.prototype.hasOwnProperty.call(config[lang], loc)
  ) {
    locale = configString[lang][loc];
  } else if (
    Object.prototype.hasOwnProperty.call(config, lang) &&
    Object.prototype.hasOwnProperty.call(config[lang], 'default')
  ) {
    locale = configString[lang].default;
  }

  const formattedString = formatLocaleString(locale);
  if (storage && storage.getItem(storageLocaleKey) !== formattedString) {
    storage.setItem(storageLocaleKey, formattedString);
  }

  return locale;
};

export const getLocaleStringFormatted = (): string => {
  const locale = getLocaleString();
  return formatLocaleString(locale);
};

const formatLocaleString = (locale: string): string => {
  return `${locale.substring(0, 2)}-${locale.substring(2, 4)}`;
};

export const getTranslatedMoment = (): Moment => {
  const defaultLanguage = 'en';
  const enforcedLocale = getLocaleStringFormatted();
  let timeLang = enforcedLocale ? enforcedLocale : defaultLanguage;

  moment.locale(timeLang);
  return moment;
};
